import {
    LOGIN_SIG,
    LOGIN_SIG_SUCCESS,
    LOGIN_SIG_FAIL,

} from '../actions/types';

const INITIAL_STATE = {
    loading_auth: false,
    error_auth: '',
    token: '',

    login_sig: false,
    error_sig_auth: '',
    documento: undefined
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LOGIN_SIG: 
            return {
                ...state,
                login_sig: true,
                error_sig_auth: ''
            }
        case LOGIN_SIG_SUCCESS: 
            return {
                ...state,
                login_sig: false,
                error_sig_auth: action.message,
                documento: action.payload
            }
        case LOGIN_SIG_FAIL: 
            return {
                ...state,
                login_sig: false,
                error_sig_auth: action.payload
            }
        default:
            return state
    }
};